import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
// import ScrollToTop from "components/ScrollToTop";
import ScrollToTop from "./components/ScrollToTop";

// import ErrorBoundary from "components/ErrorBoundary";
import ErrorBoundary from "./components/ErrorBoundary";
// import NotFound from "pages/NotFound";
import NotFound from "./pages/NotFound";
import Homepage from './pages/homepage';
import AboutUsPage from './pages/about-us';
import LandingPage from './pages/about-uss'; // new file for testing
import ServicesUniversePage from './pages/our-services';
import ContactConsultationPage from './pages/contact-us';
import PrivacyPolicy from './pages/PrivacyPolicy';
// import PricingTable from "pages/pricing/PricingPage";
import PricingPage from './pages/pricing';
// import PricingPage from "./pricingpages/pricing";
// import LandingPage from "./pages/landing/LandingPage.jsx";  // ✅ sahi path



const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/services" element={<ServicesUniversePage />} />
        <Route path="/contact" element={<ContactConsultationPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cost" element={<PricingPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;

// Feature :Technology Used
// Main Engine : React.js (Functional Components)
// Design/CSS : Tailwind CSS
// Routing : React Router Dom (links ke liye)
// SEO : React Helmet
// Images: Unsplash (External Links)
// Interactivity : "React Hooks (useState, useEffect)"
